document.addEventListener("DOMContentLoaded", () => {
  const mq = window.matchMedia("(min-width: 992px)");
  let isDesktop = mq.matches;
  let resizeTimeout;

  function handleViewportChange(e) {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const nowDesktop = e.matches;

      // Só recarrega se mudou de estado (mobile ↔ desktop)
      if (nowDesktop !== isDesktop) {
        location.reload();
      }

      isDesktop = nowDesktop;
    }, 300); // ⏱️ debounce de 300ms
  }

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", handleViewportChange);
  } else {
    mq.addListener(handleViewportChange); // Safari mais antigo
  }

  // Ancoragem com scroll suave (compensando a navbar fixa)
  const SCROLL_OFFSET = 148;

  function scrollToId(id) {
    const element = document.getElementById(id);
    if (!element) return;

    const top = element.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-scroll-to]");
    if (!trigger) return;

    event.preventDefault();
    scrollToId(trigger.dataset.scrollTo);
  });

  // Barra de navegação
  let lastScrollTop = 0;
  const navbar = document.querySelector(".navbar__header .bottom");


  if (navbar) {
    window.addEventListener("scroll", function () {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop && currentScroll > 82) {
        navbar.style.top = "-50%";
      } else {
        navbar.style.top = "100%";
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
  }

  const menuItems = document.querySelectorAll(".navbar__header .menu__item");

  menuItems.forEach((item) => {
    const dropdown = item.querySelector(".menu__sublinks");
    if (!dropdown) return;

    const positionDropdown = () => {
      // Reseta para posição padrão antes de medir novamente.
      dropdown.style.right = "auto";
      dropdown.style.left = "0";

      const rect = dropdown.getBoundingClientRect();

      if (rect.right > window.innerWidth) {
        dropdown.style.left = "auto";
        dropdown.style.right = "0";
      }
    };

    item.addEventListener("mouseenter", () => {
      if (window.innerWidth <= 992) return;

      item.classList.add("active");

      // Mede com o submenu ativo para evitar medidas incorretas em elementos ocultos.
      requestAnimationFrame(positionDropdown);
    });

    item.addEventListener("mouseleave", () => {
      if (window.innerWidth <= 992) return;

      item.classList.remove("active");
    });

    item.addEventListener("click", (e) => {
      if (window.innerWidth >= 992) return;
      if (e.target.closest(".menu__sublinks a")) return;
      e.preventDefault();

      menuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
        }
      });

      item.classList.toggle("active");
    });
  });

  // Menu mobile
  const menu = document.querySelector(".navbar__header .menu-mobile");
  const wrapper = document.querySelector(".navbar__header .wrapper-mobile");
  const body = document.querySelector("body");
  const btnToggle = document.querySelector(
    ".navbar__header .navbar__mobile .mobile"
  );
  const btnClose = document.querySelector(".navbar__header .close-btn");
  const links = document.querySelectorAll(".navbar__header .menu-mobile a");

  // Abrir/fechar menu
  function toggleMenuMobile() {
    menu.classList.toggle("active");
    wrapper.classList.toggle("active");
    body.classList.toggle("active");
  }

  // Fechar menu
  function closeMenuMobile() {
    menu.classList.remove("active");
    wrapper.classList.remove("active");
    body.classList.remove("active");
  }

  // Abrir com botão de menu
  btnToggle?.addEventListener("click", function (event) {
    event.stopPropagation();
    toggleMenuMobile();
  });

  // Fechar com botão X
  btnClose?.addEventListener("click", function (event) {
    event.stopPropagation();
    closeMenuMobile();
  });

  // Fechar ao clicar fora do menu
  menu?.addEventListener("click", function (event) {
    if (!wrapper.contains(event.target)) {
      closeMenuMobile();
    }
  });

  // Fechar ao clicar em qualquer link
  links.forEach((link) => {
    link.addEventListener("click", () => {
      closeMenuMobile();
    });
  });

  // Variantes dos cards
  // const variantsCard = document.querySelectorAll(
  //   ".delucca__product-card .swiper"
  // );

  // variantsCard.forEach((wrapper) => {
  //   new Swiper(wrapper, {
  //     slidesPerView: "auto",
  //     spaceBetween: 8,
  //     freeMode: true,
  //     grabCursor: true,
  //   });
  // });

  initUpsellCartSwiper();

});
let _swiperUpsellCartInstances = [];

function initUpsellCartSwiper() {
  _swiperUpsellCartInstances.forEach((s) => s.destroy(true, true));
  _swiperUpsellCartInstances = [];

  const els = document.querySelectorAll('#cart-upsell__wrapper');
  if (!els.length) return;

  els.forEach((el) => {
    const instance = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 8,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
    });
    _swiperUpsellCartInstances.push(instance);
  });

  initUpsellCartPriceUpdates();
}

function initUpsellCartPriceUpdates() {
  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  const items = document.querySelectorAll('.cart-upsell__item');
  items.forEach((item) => {
    const select = item.querySelector('.cart-upsell__variant-select');
    if (!select) return;

    if (select._upsellPriceHandler) {
      select.removeEventListener('change', select._upsellPriceHandler);
    }

    const handler = () => {
      const variantsScript = item.querySelector('[data-upsell-variants]');
      if (!variantsScript) return;

      let variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

      const selectedVariant = variants.find((v) => String(v.id) === String(select.value));
      if (!selectedVariant) return;

      const currentEl = item.querySelector('[data-upsell-current]');
      const compareEl = item.querySelector('[data-upsell-compare]');

      if (currentEl) currentEl.textContent = formatMoney(selectedVariant.price);

      if (compareEl) {
        if (selectedVariant.compare_at_price > selectedVariant.price) {
          compareEl.textContent = formatMoney(selectedVariant.compare_at_price);
          compareEl.classList.remove('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('hidden');
        }
      }
    };

    select._upsellPriceHandler = handler;
    select.addEventListener('change', handler);
  });
}

(function () {
  "use strict";

  /**
   * Inicializa os Swipers de variantes dentro de um contexto
   * @param {HTMLElement|Document} context
   */
  function initVariantSwipers(context) {
    context = context || document;

    const swipers = context.querySelectorAll(
      ".delucca__product-card .swiper:not(.swiper-initialized)"
    );

    if (!swipers.length) return;

    swipers.forEach((wrapper) => {
      new Swiper(wrapper, {
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
      });
    });
  }

  /**
   * Inicializa a navbar fixa de ancoragem dentro de um contexto
   * @param {HTMLElement|Document} context
   */
  function initStickyAnchorNavbar(context) {
    context = context || document;

    const navbar = context.querySelector("#delucc-navbar");
    const sentinel = context.querySelector("#delucc-sentinel");
    if (!navbar || !sentinel) return;

    if (navbar.dataset.deluccaStickyBound === "true") return;
    navbar.dataset.deluccaStickyBound = "true";

    let triggerPoint = 0;
    let cachedHeaderBottom = 0;

    function measureHeaderBottom() {
      const baseHeight = window.innerWidth >= 992 ? 124 : 108;
      const marqueeEl = document.getElementById("customInfiniteMarquee");
      const marqueeH = marqueeEl ? marqueeEl.getBoundingClientRect().height : 0;
      return baseHeight + marqueeH;
    }

    function calculateTrigger() {
      cachedHeaderBottom = measureHeaderBottom();
      triggerPoint = sentinel.getBoundingClientRect().top + window.scrollY - cachedHeaderBottom;
    }

    function onScroll() {
      if (window.scrollY >= triggerPoint) {
        navbar.classList.add("is-fixed");
        navbar.style.top = cachedHeaderBottom + "px";
      } else {
        navbar.classList.remove("is-fixed");
        navbar.style.top = "";
      }
    }

    calculateTrigger();
    onScroll();

    window.addEventListener("load", () => {
      calculateTrigger();
      onScroll();
    });

    const headerGroup = document.getElementById("header-group");
    if (headerGroup) {
      new MutationObserver(() => {
        calculateTrigger();
        onScroll();
      }).observe(headerGroup, { childList: true, subtree: false });
    }

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", () => {
      calculateTrigger();
      onScroll();
    });
  }

  function initQuickbuyModal() {
    if (document.documentElement.dataset.deluccaQuickbuyBound === "true") return;

    const modal = document.getElementById("delucca-quickbuy-modal");
    if (!modal) return;

    const content = modal.querySelector("[data-quickbuy-modal-content]");
    const closeButton = modal.querySelector("[data-quickbuy-close]");

    if (!content) return;

    document.documentElement.dataset.deluccaQuickbuyBound = "true";

    let swiperMain = null;
    let swiperThumbs = null;
    let activeQuickbuyProductId = null;

    const destroyGallery = () => {
      if (swiperMain && typeof swiperMain.destroy === "function") {
        swiperMain.destroy(true, true);
      }
      if (swiperThumbs && typeof swiperThumbs.destroy === "function") {
        swiperThumbs.destroy(true, true);
      }
      swiperMain = null;
      swiperThumbs = null;
    };

    const closeModal = () => {
      if (!modal.open) return;
      modal.close();
      destroyGallery();
      activeQuickbuyProductId = null;
      content.innerHTML = "";
    };

    const updatePriceAndAvailability = (scope) => {
      const optionSelects = Array.from(scope.querySelectorAll("[data-quickbuy-option-select]"));
      const optionInputs = Array.from(scope.querySelectorAll("[data-quickbuy-option-input]"));
      const variantsScript = scope.querySelector("[data-quickbuy-variants]");
      const variantsInline = scope.dataset.quickbuyVariants || "";
      const variantIdInput = scope.querySelector("[data-quickbuy-variant-id]");
      const compareEl = scope.querySelector("[data-quickbuy-compare]");
      const currentEl = scope.querySelector("[data-quickbuy-current]");
      const installmentsEl = scope.querySelector("[data-quickbuy-installments]");
      const atcButton = scope.querySelector('add-to-cart-component [ref="addToCartButton"]');
      const quantityInput = scope.querySelector('quantity-selector-component input[name="quantity"]');
      const quantityButtons = scope.querySelectorAll("quantity-selector-component button");

      if (!atcButton) return;

      let variants = [];
      if (variantsScript?.textContent) {
        try {
          variants = JSON.parse(variantsScript.textContent);
        } catch (error) {
          console.error(error);
        }
      }

      if (!variants.length && variantsInline) {
        try {
          variants = JSON.parse(variantsInline);
        } catch (error) {
          console.error(error);
        }
      }

      if (!variants.length) {
        if (variantIdInput?.value) {
          atcButton.disabled = false;
          if (quantityInput) {
            quantityInput.disabled = false;
          }
          quantityButtons.forEach((button) => {
            button.disabled = false;
          });
        }
        return;
      }

      const formatMoney = (cents) => {
        const value = Number(cents || 0) / 100;
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(value);
      };

      const selectedValues = [];

      if (optionInputs.length) {
        const groupedByOption = optionInputs.reduce((grouped, input) => {
          const optionIndex = Number.parseInt(input.dataset.optionIndex || "", 10);
          if (Number.isNaN(optionIndex)) return grouped;
          if (!grouped[optionIndex]) grouped[optionIndex] = [];
          grouped[optionIndex].push(input);
          return grouped;
        }, []);

        groupedByOption.forEach((inputs, optionIndex) => {
          if (!Array.isArray(inputs) || !inputs.length) return;
          const checkedInput = inputs.find((input) => input.checked) || inputs[0];
          selectedValues[optionIndex] = checkedInput?.value || "";

          inputs.forEach((input) => {
            const label = input.closest("label");
            if (!label) return;
            if (input.checked) {
              label.classList.add("is-active");
            } else {
              label.classList.remove("is-active");
            }
          });
        });
      } else {
        optionSelects.forEach((select, optionIndex) => {
          selectedValues[optionIndex] = select.value;
        });
      }

      const selectedLabels = Array.from(scope.querySelectorAll("[data-quickbuy-option-selected]"));
      if (selectedLabels.length) {
        selectedLabels.forEach((label) => {
          const optionIndex = Number.parseInt(label.dataset.optionIndex || "", 10);
          if (Number.isNaN(optionIndex)) return;
          const value = selectedValues[optionIndex];
          if (value) {
            label.textContent = `(${value})`;
            label.hidden = false;
          } else {
            label.textContent = "";
            label.hidden = true;
          }
        });
      }

      let selectedVariant = null;

      if (variants.length) {
        if (selectedValues.length) {
          selectedVariant = variants.find((variant) => {
            if (!Array.isArray(variant.options)) return false;
            return selectedValues.every((value, index) => variant.options[index] === value);
          });
        } else if (variantIdInput?.value) {
          selectedVariant = variants.find((variant) => String(variant.id) === String(variantIdInput.value));
        }

        if (!selectedVariant) {
          selectedVariant = variants[0];
        }
      }

      const variantId = selectedVariant?.id ? String(selectedVariant.id) : "";
      const isAvailable = Boolean(selectedVariant?.available);
      const variantPrice = Number(selectedVariant?.price || 0);
      const variantComparePrice = Number(selectedVariant?.compare_at_price || 0);

      const syncGalleryByVariant = () => {
        if (!selectedVariant || !swiperMain) return;

        const slides = Array.from(scope.querySelectorAll(".swipper-container .swiper-slide"));
        if (!slides.length) return;

        const mediaIdCandidates = [
          selectedVariant?.featured_media?.id,
          selectedVariant?.featured_image?.id,
          selectedVariant?.image_id,
        ]
          .filter(Boolean)
          .map((id) => String(id));

        let targetIndex = -1;

        if (mediaIdCandidates.length) {
          targetIndex = slides.findIndex((slide) => mediaIdCandidates.includes(String(slide.dataset.mediaId || "")));
        }

        if (targetIndex === -1 && selectedVariant?.featured_image?.src) {
          const normalize = (url) => String(url || "").replace(/^https?:/, "").split("?")[0];
          const targetSrc = normalize(selectedVariant.featured_image.src);

          targetIndex = slides.findIndex((slide) => {
            const image = slide.querySelector("img");
            const slideSrc = normalize(image?.getAttribute("src") || image?.getAttribute("data-src") || "");
            return slideSrc && targetSrc && (slideSrc.includes(targetSrc) || targetSrc.includes(slideSrc));
          });
        }

        if (targetIndex > -1) {
          swiperMain.slideTo(targetIndex, 250);

          if (swiperThumbs) {
            swiperThumbs.slideTo(targetIndex, 250);
          }
        }
      };

      syncGalleryByVariant();

      if (currentEl) {
        currentEl.textContent = formatMoney(variantPrice);
      }

      if (compareEl) {
        if (variantComparePrice > variantPrice) {
          compareEl.textContent = formatMoney(variantComparePrice);
          compareEl.classList.remove("hidden");
        } else {
          compareEl.textContent = "";
          compareEl.classList.add("hidden");
        }
      }

      if (installmentsEl) {
        let installmentsCount = 0;

        if (variantPrice > 24999) {
          installmentsCount = 5;
        } else if (variantPrice > 19999) {
          installmentsCount = 4;
        } else if (variantPrice > 14999) {
          installmentsCount = 3;
        } else if (variantPrice > 9999) {
          installmentsCount = 2;
        } else if (variantPrice > 0) {
          installmentsCount = 0;
        }

        if (installmentsCount > 1) {
          const installmentValue = formatMoney(variantPrice / installmentsCount);
          const pixValue = formatMoney(variantPrice * 0.95);
          installmentsEl.innerHTML = `
            <b>${installmentsCount}x</b> de <b>${installmentValue}</b> sem juros no cartão ou <b>${pixValue}</b> via Pix
          `;
        } else {
          const pixValue = formatMoney(variantPrice * 0.95);
          installmentsEl.innerHTML = `ou <b>${pixValue}</b> via Pix`;
        }
      }

      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }

      atcButton.disabled = !isAvailable;

      if (quantityInput) {
        quantityInput.disabled = !isAvailable;

        if (!isAvailable) {
          quantityInput.value = "1";
        }
      }

      quantityButtons.forEach((button) => {
        button.disabled = !isAvailable;
      });
    };

    const initGallery = (scope) => {
      const thumbsEl = scope.querySelector(".swipper-thumbs");
      const mainEl = scope.querySelector(".swipper-container");

      if (!mainEl || typeof Swiper === "undefined") return;

      if (thumbsEl) {
        swiperThumbs = new Swiper(thumbsEl, {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            992: { direction: "vertical" },
            0: { direction: "horizontal" },
          },
        });
      }

      swiperMain = new Swiper(mainEl, {
        spaceBetween: 10,
        navigation: {
          nextEl: mainEl.querySelector(".swiper-button-next"),
          prevEl: mainEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: mainEl.querySelector(".swiper-pagination"),
          type: "fraction",
        },
        thumbs: swiperThumbs ? { swiper: swiperThumbs } : undefined,
      });
    };

    const openFromCard = (card) => {
      const template = card.querySelector(".delucca-quickbuy-template");
      if (!(template instanceof HTMLTemplateElement)) return;

      destroyGallery();
      content.innerHTML = "";

      const fragment = template.content.cloneNode(true);
      content.appendChild(fragment);

      const quickbuyRoot = content.querySelector(".delucca-quickbuy-product");
      if (!quickbuyRoot) return;
      activeQuickbuyProductId = quickbuyRoot.dataset.productId || null;
      quickbuyRoot.dataset.quickbuyVariants = card.dataset.variants || "";

      quickbuyRoot
        .querySelectorAll("script:not([data-quickbuy-variants])")
        .forEach((node) => node.remove());
      initGallery(quickbuyRoot);

      const optionSelects = quickbuyRoot.querySelectorAll("[data-quickbuy-option-select]");
      const optionInputs = quickbuyRoot.querySelectorAll("[data-quickbuy-option-input]");
      if (optionSelects.length) {
        updatePriceAndAvailability(quickbuyRoot);

        optionSelects.forEach((select) => {
          select.addEventListener("change", () => updatePriceAndAvailability(quickbuyRoot));
        });
      } else if (optionInputs.length) {
        updatePriceAndAvailability(quickbuyRoot);

        optionInputs.forEach((input) => {
          input.addEventListener("change", () => updatePriceAndAvailability(quickbuyRoot));
        });
      } else {
        updatePriceAndAvailability(quickbuyRoot);
      }

      modal.showModal();
    };

    document.addEventListener("cart:update", () => {
      requestAnimationFrame(initUpsellCartSwiper);
    });

    document.addEventListener("cart:update", (event) => {
      if (!modal.open || !activeQuickbuyProductId) return;

      const source = event?.detail?.data?.source;
      const productId = String(event?.detail?.data?.productId || "");

      if (source === "product-form-component" && productId === String(activeQuickbuyProductId)) {
        closeModal();
      }
    });

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-quickbuy-open]");

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const card = trigger.closest(".delucca__product-card");
        if (card) {
          openFromCard(card);
        }

        return;
      }

      if (event.target.closest("[data-quickbuy-close]")) {
        closeModal();
      }
    });

    document.addEventListener("keydown", (event) => {
      const trigger = event.target.closest("[data-quickbuy-open]");
      if (!trigger) return;

      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();

      const card = trigger.closest(".delucca__product-card");
      if (card) {
        openFromCard(card);
      }
    });

    modal.addEventListener("click", (event) => {
      const rect = modal.getBoundingClientRect();
      const isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!isInDialog) {
        closeModal();
      }
    });

    closeButton?.addEventListener("click", closeModal);
  }

  /**
   * Inicialização no carregamento inicial da página
   */
  function onDomReady() {
    initVariantSwipers(document);
    initQuickbuyModal();
    initStickyAnchorNavbar(document);
    if (typeof Fancybox !== "undefined") {
      Fancybox.bind("[data-fancybox]", {
        Carousel: {
          Thumbs: {
            type: "classic",
          },
          Toolbar: {
            display: {
              left: ["counter"],
              middle: ["zoomIn", "zoomOut", "reset"],
              right: ["close"],
            },
          }
        },
      });
    }
  }

  /**
   * Shopify Sections (renderizadas via AJAX)
   */
  function onShopifySectionLoad(event) {
    if (!event || !event.target) return;
    initVariantSwipers(event.target);
    initQuickbuyModal();
    initStickyAnchorNavbar(event.target);
  }

  /**
   * Observer para produtos carregados dinamicamente (infinite scroll / AJAX)
   */
  function observeDynamicProducts() {
    const productContainer =
      document.querySelector("[data-product-grid]") ||
      document.querySelector("#ProductGridContainer") ||
      document.querySelector(".product-grid");

    const target = productContainer || document.body;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          // Se o próprio node for um card
          if (node.matches && node.matches(".delucca__product-card")) {
            initVariantSwipers(node);
            return;
          }

          // Se o node contiver cards
          if (node.querySelectorAll) {
            const cards = node.querySelectorAll(".delucca__product-card");
            if (cards.length) {
              cards.forEach((card) => initVariantSwipers(card));
            }
          }
        });
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  function initFreeShippingVisibility() {
    const THRESHOLD = 25000; // R$250,00 em centavos no Shopify — ou usamos o DOM

    // Parseia texto "R$ 249,99" → 249.99
    const parsePrice = (text) => {
      if (!text) return 0;
      const cleaned = (text || '').replace(/[^\d,]/g, '').replace(',', '.');
      return parseFloat(cleaned) || 0;
    };

    const getCurrentPrice = () => {
      const el = document.querySelector('.product-details product-price span.price');
      return el ? parsePrice(el.textContent.trim()) : 0;
    };

    const evaluateFreeShipping = () => {
      const price = getCurrentPrice();
      const shipPriceEls = document.querySelectorAll('span.ship-price');

      shipPriceEls.forEach((span) => {
        const text = span.textContent.trim().toLowerCase();
        if (!text.includes('grátis') && !text.includes('gratis')) return;

        // Sobe na árvore até encontrar a "linha" do resultado de frete
        const row = span.closest('tr, li, [class*="ship-option"], [class*="shipping-option"]')
          || span.parentElement?.parentElement
          || span.parentElement;

        if (!row) return;
        row.style.display = price < 250 ? 'none' : '';
      });
    };

    // Vigiar inserções dinâmicas (resultados do app de frete)
    const observer = new MutationObserver(evaluateFreeShipping);
    observer.observe(document.body, { childList: true, subtree: true });

    // Re-avaliar quando a variante mudar (DOM do preço já foi atualizado nesse ponto)
    document.addEventListener('variant:update', evaluateFreeShipping);

    // Avaliação inicial (caso a página já tenha resultados)
    evaluateFreeShipping();
  }

  /**
   * Bind de eventos globais
   */
  document.addEventListener("DOMContentLoaded", onDomReady);
  document.addEventListener("shopify:section:load", onShopifySectionLoad);

  /**
   * Start observer
   */
  observeDynamicProducts();
  initFreeShippingVisibility();
})();